// PreFiltrosListagem/index.tsx - Ajustado
import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import SelectSetor from "../../../../../components/SelectsSimpleApiQuery/SelectSetor";
import SelectCategoriaPrincipal from "../../../../../components/SelectsSimpleApiQuery/SelectCategoriaPrincipal";
import SelectDepartamentoEstoqueMultiple from "../../../../../components/SelectsSimpleApiQuery/SelectDepartamentoEstoque/Multiple";
import { FilterState } from "../ListarTodos";


interface PreFiltrosModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (filters: FilterState) => void;
  initialFilters?: FilterState;
}

export default function DialogFiltrosModal({
  open,
  onClose,
  onConfirm,
  initialFilters = {},
}: PreFiltrosModalProps) {
  const [internalFilters, setInternalFilters] = useState<FilterState>(initialFilters);


  const handleInsertFiltros = (prop: keyof FilterState, value: any) => {
    setInternalFilters(prevState => ({
      ...prevState,
      [prop]: value
    }));
  }

  const handleConfirm = () => {
    const validFilters = Object.fromEntries(
      Object.entries(internalFilters).filter(([_, value]) => {
        if (Array.isArray(value)) return value.length > 0;
        return value !== undefined && value !== null && value !== '';
      })
    ) as FilterState;

    onConfirm(validFilters);
    onClose();
  }

  const clearFiltros = () => {
    setInternalFilters({});
    onConfirm({});
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Filtrar Produtos</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, pb: 2 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <SelectCategoriaPrincipal
                value={internalFilters.categoria || []}
                onChange={(categoria) =>
                  handleInsertFiltros("categoria", categoria)
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <SelectDepartamentoEstoqueMultiple
                value={internalFilters.departamento || []}
                onChange={(departamento) => handleInsertFiltros("departamento", departamento)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <SelectSetor
                value={internalFilters.setor || []}
                onChange={(setor) => handleInsertFiltros("setor", setor)}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={clearFiltros} color="primary" variant="outlined">
          Limpar
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
}